<template>
    <div>
        <div v-if="user && ! user.packet" class="announcement">
            <div v-if="user.user_type == 'gewerblich' && user.was_old == 0">
                <h4  v-html="$t('intern_objekte_list.kein_paket_gewerblich_heading')"></h4>
                <div v-html="$t('intern_objekte_list.kein_paket_gewerblich')"></div>
            </div>
            <div v-else-if="user.user_type == 'gewerblich' && user.was_old == 1">
                <h4  v-html="$t('intern_objekte_list.kein_paket_gewerblich_old_heading')"></h4>
                <div v-html="$t('intern_objekte_list.kein_paket_gewerblich_old')"></div>
            </div>
            <div v-else-if="object_id && object_id > 0">
                <h1 class="text-center"><router-link class="mm-link" :to="{name: 'inserat-booking' , params: {object_id: this.object_id}}">Jetzt buchen!</router-link></h1>
            </div>
            <div v-else>
                <h1 class="text-center"><router-link class="mm-link" :to="{name: 'inserat-create'}">Jetzt inserieren!</router-link></h1>
            </div>
        </div>
        <div v-if="opened_invoices.length > 0 && sepaInfoMissing" class="alert alert-warning">
            {{$t('intern_paymentdata.rechnung_bezahlen_info_label')}}
            <router-link :to="{ name: 'invoice-payment', params: {invoice_id: opened_invoices[0].id}}" class="text-warning">{{$t('intern_paymentdata.rechnung_bezahlen_link')}}</router-link>
        </div>
        <div v-else-if="opened_invoices.length > 0 && !sepaInfoMissing" class="alert alert-warning">
            <div v-for="invoice in opened_invoices" :key="invoice.id">
                <router-link :to="{ name: 'invoice-payment', params: {invoice_id: invoice.id}}" class="text-warning">{{$t('intern_objekte_list.rechnung_bezahlen_link')}}</router-link>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                //user: this.$store.state.user,
                opened_invoices: [],
                objects: this.$store.state.objects,
                object_id : 0,
                //isSepaInfoMissing : 0
            }
        },
        props:['user', 'sepaInfoMissing'],
        beforeCreate() {
            this.$http.get('invoiceApi/getOpenedInvoice').then( response => {
                this.opened_invoices = JSON.parse(response.data);

                if(this.user && !this.user.packet){
                    this.$http.get('objectApi/getLatestObject?user_id=' + this.user.id).then(response => {
                      this.object_id = JSON.parse(response.data);
                    }).catch(error => {
                      console.log(error);
                    })
                }
            }).catch(error => {
                console.log(error);
            });

        }
    }
</script>

<style scoped>
.announcement{
    padding: 40px;
    border: 5px solid #5FA963;
    border-radius: 8px;
    margin-bottom: 20px;
}
.announcement h4, .announcement h1{
    color: #5FA963;
}
.announcement>div>div {
    text-align: justify;
}
</style>
